import { render, staticRenderFns } from "./VeJwCjFreeList.vue?vue&type=template&id=118882aa&scoped=true"
import script from "./VeJwCjFreeList.vue?vue&type=script&lang=js"
export * from "./VeJwCjFreeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118882aa",
  null
  
)

export default component.exports